export const actionMap = {}

export const defaultState = {
    flightId: undefined,
    data: undefined,
    isLoading: true,
    selectedIds: undefined,
    loadingIds: undefined,
    blobUrl: undefined,
    loadingToolbarButtons: undefined,
    flightInfo: undefined
}

export default (reduxState = defaultState, action) => {
    if (action !== undefined && actionMap[action.type]) {
        return actionMap[action.type](reduxState, action)
    }
    return reduxState
}



// WEBPACK FOOTER //
// ./src/screens/briefing/products/reducers/index.js